// extracted by mini-css-extract-plugin
export default {"icon":"my-location-marker__icon___6_SB3"};